import React from 'react';
import { ContentBox } from '../ContentBox/ContentBox';
import { formatterCurrency } from '@common/utils/formatters/formatter';

interface IProps {
  loanSelected: any;
}

export const BoxBudget: React.FC<IProps> = ({ loanSelected }: IProps) => {

  const purchasePrice = formatterCurrency(loanSelected?.salesforceData?.budget?.purchasePrice || loanSelected?.loanData?.price);

  const data = {
    asIsValue: formatterCurrency(loanSelected?.salesforceData?.budget?.asIsValue || loanSelected?.loanData?.price),
    appraiserAsIsValue: loanSelected?.salesforceData?.budget?.appraiserAIV ? formatterCurrency(loanSelected?.salesforceData?.budget?.appraiserAIV) : 'Awaiting appraisal',
    currentLoanBalance: formatterCurrency(loanSelected?.salesforceData?.budget?.currentLoanBalance || loanSelected?.loanData?.currentLoanBalance),

    estimatedARV: formatterCurrency(loanSelected?.salesforceData?.budget?.estimatedARV || loanSelected?.loanData?.afterRepairValue),
    appraiserARV: loanSelected?.salesforceData?.budget?.appraiserARV ? formatterCurrency(loanSelected?.salesforceData?.budget?.appraiserARV) : 'Awaiting appraisal',
    constructionReserve: formatterCurrency(loanSelected?.salesforceData?.budget?.constructionReserve || loanSelected?.loanData?.constructionBudget),
    rehabBudget: formatterCurrency(loanSelected?.salesforceData?.budget?.rehabBudget || loanSelected?.loanData?.constructionBudget),
    loanToCost: `${((loanSelected?.loanData?.selectedOption?.ltc) * 100).toFixed(2)}%`,
    advanceAmount: formatterCurrency(loanSelected?.loanData?.selectedOption?.totalLoanAmount - (loanSelected?.loanData?.constructionBudget ?? 0)),

    monthlyRent: formatterCurrency(loanSelected?.salesforceData?.budget?.monthlyRent || loanSelected?.loanData?.monthlyRent),
    annualTaxes: formatterCurrency(loanSelected?.salesforceData?.budget?.annualTaxes || loanSelected?.loanData?.annualTaxes),
    annualInsurance: formatterCurrency(loanSelected?.salesforceData?.budget?.annualInsurance || loanSelected?.loanData?.annualInsurance),
    annualHoa: formatterCurrency(loanSelected?.salesforceData?.budget?.annualHoa || loanSelected?.loanData?.annualHoa),
    dscr: loanSelected?.salesforceData?.budget?.dscr || loanSelected?.loanData?.selectedOption?.dscr,
  }

  return (
    <ContentBox
      label={'Budget and valuation'}
      content={[
        ...(
          loanSelected?.purpose === "Purchase" ?
            [
              { field: 'Purchase Price', value: purchasePrice },
            ]
            :
            [
              { field: 'As-is-value', value: data.asIsValue, extra: { field: 'Appraiser’s as-is-value', value: data.appraiserAsIsValue } },
              { field: 'Current Loan Balance', value: data.currentLoanBalance },
            ]
        ),
        ...(
          loanSelected?.type === "Fix and Flip" ?
            [
              { field: 'Estimated ARV', value: data.estimatedARV, extra: { field: 'Appraiser’s ARV', value: data.appraiserARV } },
              { field: 'Construction reserve', value: data.constructionReserve },
              { field: 'Rehab Budget', value: data.rehabBudget },
            ]
            :
            []
        ),
        ...(
          loanSelected?.type === "Fix and Flip" ?
            [
              { field: 'Loan-to-cost', value: data.loanToCost },
              { field: 'Advance amount', value: data.advanceAmount },
            ]
            :
            []
        ),
        ...(
          loanSelected?.type === "Rental" ?
            [
              { field: 'Monthly Rent', value: data.monthlyRent },
              { field: 'Annual Taxes', value: data.annualTaxes },
              { field: 'Annual Insurance', value: data.annualInsurance },
              { field: 'Annual HOA', value: data.annualHoa },
              { field: 'DSCR', value: data.dscr },
            ]
            :
            []
        )
      ]}
    />
  );
}